import { Box, Typography } from "@mui/material";
import { useState } from "react";
import useWarehouseDetailDistribution from "src/hooks/warehouse/useWarehouseDetailDistribution";
import { v4 as uuid } from "uuid";
import BalancePMPercentageTableRow from "../balance/BalancePMPercentageTableRow";
import useAuthGlobal from "src/context/useAuthGlobal";
import appConfig from "src/config/env";

export default function useWarehouseDistribution({ product }) {
  const { userMe } = useAuthGlobal();
  const [pagi, setPagi] = useState({
    skip: 0,
    limit: 50,
  });
  const { data: wDistribution } = useWarehouseDetailDistribution({ id: userMe?.currentWarehouse?._id, limit: 50, skip: 0, sortOrder: "asc", product: product });

  const bodyList = Array.isArray(wDistribution?.data)
    ? wDistribution?.data?.map((v) => ({
        ...v,
        productComp: (
          <Box
            display="flex"
            gap={1}
          >
            <Box
              sx={{
                width: "46px",
                height: "46px",
                background: `url(${appConfig.API_FILE}/${v?.product?.imageUrl})`,
                backgroundSize: "100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                border: "1px solid var(--main-grey)",
                borderRadius: "8px",
              }}
            />
            <Typography variant="body2">{v?.product?.name}</Typography>
          </Box>
        ),
        col: <></>,
        includesRow: (
          <BalancePMPercentageTableRow
            key={v?._id}
            product={v?.product}
            productModels={v?.productModels}
            warehouse={userMe?.currentWarehouse?._id}
          />
        ),
      }))
    : [];

  const sortData = ["productComp", "col"];

  const header = [
    {
      id: uuid(),
      title: "Sản phẩm/ Phân loại",
      width: "200px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Tỷ lệ dung tích kho",
      width: "100px",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      align: "center",
      width: "100px",
    },
  ];

  return { header, bodyList, sortData, setPagi, pagi };
}
